import { FiChevronLeft } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

const ValentinesFaq = () => {
  const navigate = useNavigate();

  return (
    <div style={{ padding: '20px', color: '#FFFFFF' }}>
      <div style={{ display: 'flex', alignItems: 'center', marginTop: '30px' }}>
        <button className="back-button" onClick={() => navigate('/home')}>
          <FiChevronLeft className="back-button-icon" />
        </button>
        <div style={{ color: '#FFFFFF', fontSize: '18px', fontWeight: 700, marginLeft: '20px' }}>
          Five Years of GoSats - FAQ
        </div>
      </div>
      <div>
        <ul className="mt-4">
          <li>
            <p className="FAQ-Question">What is the 5-Year Anniversary Campaign on GoSats?</p>
            <p className="paragraph">
            GoSats is celebrating its 5-Year Anniversary from 19th February to 23rd February with special rewards and benefits every day. The campaign focuses on 5 ways to benefit over 5 days, including loyalty rewards, boosted card rewards, vouchers, gold offers, and exclusive Elite Card pricing.
            </p>
          </li>
          <li>
            <p className="FAQ-Question">When is the Anniversary Campaign applicable?</p>
            <p className="paragraph">
            The Anniversary Campaign is valid from 19th February, 12:00 AM to 23rd February, 11:59 PM (IST) unless specified otherwise for a particular offer.
            </p>
          </li>
          <li>
            <p className="FAQ-Question">What is the Loyalty Bonus?</p>
            <p className="paragraph">
            The Loyalty Bonus is a special Anniversary reward in sats given to users as a thank-you for being active on GoSats.
            </p>
          </li>
          <li>
            <p className="FAQ-Question">
              What card spend offers are available during the campaign?</p>
            <p className="paragraph">
            You earn 5% rewards on card spends made in the following e-commerce categories during the campaign: Fashion, Food, Travel. 1% of the rewards can be withdrawn and 4% are redeemable.
            </p>
          </li>
          <li>
            <p className="FAQ-Question">Is there any special offer on purchase of the Elite Card? </p>
            <p className="paragraph">
              Yes. The Elite Card is available at 50% off during the Anniversary Campaign.
            </p>
            <ul>
              <li>
                <p className="paragraph">
                  The discounted price is fully redeemable using SuperCoins.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <p className="FAQ-Question">
            What is the voucher offer during the Anniversary Campaign?</p>
            <p className="paragraph">
            During the period of campaign, you can earn 500 sats when you purchase 5 vouchers.
            </p>
            <ul>
              <li>
                <p className="paragraph">
                The reward is applicable only if minimum value of ₹300 is spent on 5 voucher.
                </p>
              </li>
              <li>
                <p className="paragraph">
                Purchases of fewer than 5 vouchers are not eligible
                </p>
              </li>
              <li>
                <p className="paragraph">
                  Amazon pay and Phonepe vouchers are not eligible for the voucher reward.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <p className="FAQ-Question">
              Is there any Gold offer during the campaign?</p>
            <p className="paragraph">
              Yes. You can buy Gold instantly and get a 5% discount, capped at ₹50.
            </p>
            <p className="paragraph">
            Minimum gold purchase amount: ₹500.
            </p>
          </li>
          <li>
            <p className="FAQ-Question">
            What is “Highest Stacker Kaun”?
            </p>
            <p className="paragraph">
              Highest Stacker Kaun” is a special Anniversary engagement where top users based on stacking activity during the campaign period will be featured or rewarded.
            </p>
              <ul>
                <li>
                  <p className="paragraph">
                    BBPS and SatsPay transactions are not eligible for the “Highest Stacker Kaun”.
                  </p>
                </li>
                <li>
                  <p className="paragraph">
                    2% of lumpsum gold purchases will be considered for the "Highest Stacker Kaun". ₹300 should be the minimum purchase amount.
                  </p>
                </li>
              </ul>
            </li>
          <li>
            <p className="FAQ-Question">
            What if I don’t receive my Anniversary rewards?</p>
            <p className="paragraph">
              Please contact in-app support or write to support@gosats.io from your registered email ID for assistance.
            </p>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ValentinesFaq;
